import { ApiSelfServeV2Service } from 'api-clients/monolith/services/ApiSelfServeV2Service';

type OpeningsQueryParams = {
  workflowId?: string;
  title?: string;
  page?: number;
  perPage?: number;
  sortBy?: string;
  sortDirection?: 'asc' | 'desc';
  active?: boolean;
  query?: string;
  locationIds?: Array<string>;
  positionIds?: Array<string>;
  brandIds?: Array<string>;
  isSelectedForSourcing?: boolean;
};

export function getOpenings(params: OpeningsQueryParams) {
  return ApiSelfServeV2Service.getApiSelfServeV2Openings(
    params.workflowId,
    params.title,
    params.page,
    params.perPage,
    params.sortBy,
    params.sortDirection,
    params.active,
    params.query,
    params.locationIds,
    params.positionIds,
    params.brandIds,
    params.isSelectedForSourcing,
  );
}
